export const ALLOWED_ADMINS = [
    { username: "thummar_nevil", password: "Nevil@2026" },
    // { username: "nevil_nevyati", password: "Nevil@Nevyati2026" },
    { username: "modi_jenish", password: "Jenish@2026" },
    // { username: "vyom_nevyati", password: "Vyom@Nevyati2026" },
    { username: "patoliya_mithil", password: "Mithil@2026" }
    // { username: "tapan_nevyati", password: "Tapan@Nevyati2026" }
];

export const MASTER_COLOR_PALETTE = [
    { id: "black", name: "Stealth Black", hex: "#111827" },
    { id: "white", name: "Alabaster White", hex: "#f8fafc" },
    { id: "red", name: "Crimson Red", hex: "#ef4444" },
    { id: "blue", name: "Navy Blue", hex: "#1d4ed8" },
    { id: "green", name: "Forest Green", hex: "#15803d" },
    { id: "gold", name: "Luxury Gold", hex: "#b45309" }
];